module.exports = __webpack_public_path__ + "static/media/z1.eee7f713.JPG";